import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "rgb(255, 192, 1)",
    },
    secondary: {
      main: "#f44336",
    },
    danger:{
      main: "#ff0800",
    }
  },
});

export default theme;
